function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
}

(function ($) {
    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    $(document).ready(function () {

        // Apply style to a if touch device
        if (isTouchDevice()) {
            $('a').addClass('mobile');
            $('a').removeClass('desktop');
        } else {
            $('a').addClass('desktop');
            $('a').removeClass('mobile');
        }

        $('.store-list-container h2').each(function () {
            var children = $(this).nextUntil('h2');
            $(children).appendTo(this);
        });

        $(function ($) {
            var num_cols = 3,
                container = $('.store-list-container'),
                listItem = 'h2',
                listClass = 'sub-list';
            container.each(function () {
                var items_per_col = [],
                    items = $(this).find(listItem),
                    min_items_per_col = Math.floor(items.length / num_cols),
                    difference = items.length - (min_items_per_col * num_cols);
                for (var i = 0; i < num_cols; i++) {
                    if (i < difference) {
                        items_per_col[i] = min_items_per_col + 1;
                    } else {
                        items_per_col[i] = min_items_per_col;
                    }
                }
                for (var i = 0; i < num_cols; i++) {
                    $(this).append($('<div ></div>').addClass(listClass));
                    for (var j = 0; j < items_per_col[i]; j++) {
                        var pointer = 0;
                        for (var k = 0; k < i; k++) {
                            pointer += items_per_col[k];
                        }
                        $(this).find('.' + listClass).last().append(items[j + pointer]);
                    }
                }
            });
        });

        // Top section heights
        $('.fullscreen-section .swiper-slide').css({'height': windowHeight * 0.8});
    });

    $(window).resize(function () {
        // Get Window Width and Height on resize
        windowWidth = $(window).outerWidth();
        windowHeight = $(window).height();

        $('.fullscreen-section .swiper-slide').css({'height': windowHeight * 0.8});
    });
})(jQuery);
